'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('end_user_confirm', {
        url: '/user_confirm/:token',
        template: '<end-user-confirm></end-user-confirm>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/end_user_confirm/end_user_confirm.routes.js